import moment from 'moment';

export const types = [{ label: 'Erasure', value: 'erasure' }, { label: 'Diagnose', value: 'diagnose' }];

export const formatProductTypes = (type, translations) => {
    switch (type) {
        case 'PCProduct':
            return translations['pc_product'] || 'PC Product'
        case 'MobileProduct':
            return translations['mobile_product'] || 'Mobile Product'
        case 'DisplayProduct':
            return translations['display_product'] || 'Display Product'
        case 'StorageProduct':
            return translations['storage_product'] || 'Storage Product'
        default:
            return null;
    }
};

export const getProductType = (type, translations) => {
    switch (type) {
        case 'mobile_client':
            return translations?.['mobile_product'] || 'Mobile Product'
        case 'work_client':
            return translations?.['work'] || "Work"
        case 'remote_client':
            return translations?.['remote'] || 'Remote'
        default:
            return "";
    }
};

export const getNameAndExt = (fileName) => {
    if (fileName) {
        let ext = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName.toLowerCase();
        return fileName.split(ext).join(ext.toLowerCase());
    }
    return `file_${moment().valueOf()}.png`;
};

export const makeTranslates = (value) => {
    return value.split(/(?=[A-Z][a-z])/g).join(" ").replace(/\s/g, '_').toLowerCase() || value + ""
}

export const typeLookup = translations => types.reduce((obj, item) => Object.assign(obj, { [item.value]: translations[item.value] || item.label }), {});

export const defaultFilterType = (object) => {
   let defaultFilterList = [];
    if (object) {
        for (const [key] of Object.entries(object)) {
            defaultFilterList.push(key);
        }
    }
    return defaultFilterList;
}
